<div class="admin-layout" [class.withoutScroll]="withoutScroll">
  <div class="container flex gap-48">
    <yrx-sidebar [navigation]="adminNavigation">
      <ng-container sidebar-top-content>
        <yrx-spacing type="L"></yrx-spacing>
        <yrx-link [routerLink]="['/platform']" [iconReverse]="true"  [iconStroked]="true" icon="arrow-left">Вернуться на сайт</yrx-link>
        <yrx-spacing type="S"></yrx-spacing>
      </ng-container>
    </yrx-sidebar>
    <div class="scrollable flex flex_column flex_grow">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
